import * as angular from 'angular';
import '../app.common';
import { mixinTranslation } from '../app.common/translation';

var module = angular.module('app.retailes.common', ['treeControl', 'textAngular', 'pascalprecht.translate']);
mixinTranslation(module, ['en', 'no'], 'retailer.common');
var tsContext = require.context('.', true, /\.ts$/);
tsContext.keys().forEach(tsContext);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/index.ts